console.log("in 3d-model js");
import * as THREE from "three";
import { OrbitControls } from "https://unpkg.com/three@0.148.0/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "https://unpkg.com/three@0.148.0/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/RenderPass.js";

let scene, renderer, camera, controls, dirLight;
let Collar_style,
  Placket,
  Back_design,
  Hem_Shape,
  Cuff_style,
  Monogram,
  Pleats,
  Contrast,
  sleev;
let nCameraSize = 280;
let model, loadingText, container;
let aLight = [];
let oCurruentFabric;
let nCurruentIntensity = 10;
let intialmodel = "shirt";
container = document.getElementById("CanvasFramemobile");
const width = window.innerWidth;
const height = container.clientHeight;
fetchFabrics();

let collarStyleValue = "Classic";
let placketValue = "No_Placket";
let hemShapeValue = "tail";
let backDesignValue = "plain";
let cuffStyleValue = "Single_Rounded_Cuffs";
let cuffValue = "None";
let contrastCuffs = false;
let contrastCollar = false;
let composer, renderPass;
let allfabrics;
let sButtons_texture = "Beige";
let defaultfabriccode;

const DEFAULT_FABRIC_TEXTURE_URL ="https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/default/Poly_Wool_Fabric_Base_Map1-2.jpg";

const DEFAULT_FABRIC_FALLBACK = {
    repeatable_color_image_url: null,
    repeatable_normal_image_url: null,
    color_r: 128,
    color_g: 128,
    color_b: 128,
    tiling_info: { color_tiling_x: 20, color_tiling_y: 20 },
};

const params = { color: 0xffff00 };

const init = () => {
  scene = new THREE.Scene();
  // scene.background = new THREE.Color(0x000b1b2f);
  camera = new THREE.OrthographicCamera(
    width / -570,
    width / 570,
    height / 570,
    height / -570,
    1,
    1000
  );
  camera.position.z = 60;
  camera.updateProjectionMatrix();
  camera.lookAt(0, 0, 0);
  renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    preserveDrawingBuffer: true,
    powerPreference: "high-performance",
  });
  renderer.toneMapping = THREE.CineonToneMapping;
  renderer.shadowMap.enabled = true;
  renderer.gammaInput = true;
  renderer.gammaOutput = true;
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(width, height);

  composer = new EffectComposer(renderer);

  renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  container.appendChild(renderer.domElement);
  loadGLTFmodel(intialmodel);
  animate();
  orbitControls();
  //loadLodingText();

  const addDirectionalLight = () => {
    dirLight = new THREE.DirectionalLight(0xffffff, 5);
    dirLight.position.set(0, 0, 0);
    dirLight.castShadow = true;
    dirLight.shadow.mapSize.width = 1024;
    dirLight.shadow.mapSize.height = 1024;

    aLight.push(dirLight);
    scene.add(dirLight);
  };

  const spotLight = new THREE.SpotLight(0x00ff00);
  spotLight.position.set(0, 0, 0);
  spotLight.target.position.set(0, 0, 0);
  scene.add(spotLight);
  scene.add(spotLight.target);

  addDirectionalLight(0, 0, 0, 8);
};

const animate = () => {
  if (controls) controls.update();
  if (dirLight) {
    dirLight.position.set(
      camera.position.x,
      camera.position.y + 10,
      camera.position.z + 2
    );
  }
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
  composer.render();
};

window.addEventListener("resize", () => {
  camera.left = width / -470;
  camera.right = width / 470;
  camera.top = height / 470;
  camera.bottom = height / -470;
  camera.updateProjectionMatrix();
  renderer.setSize(width, height);
});

async function loadGLTFmodel(glbModel) {
  const loader = new GLTFLoader();
  const staticURL1 = "https://deve6ppviy37y.cloudfront.net/";
  const fullURL = `${staticURL1}${glbModel}.glb`;
  console.log("fullURL ", fullURL);
  await loader.loadAsync(fullURL).then((glb) => {
    model = glb.scene;
    model.visible = false;
    model.scale.set(0.5, 0.5, 0.5);

    console.log(model.children[0].children);
    Collar_style = model.children[0].children.filter(
      (child) => child.name === "Coller"
    )[0];
    Collar_style = model.children[0].children.filter(
      (child) => child.name === "Coller"
    )[0];
    Placket = model.children[0].children.filter(
      (child) => child.name === "placket"
    )[0];
    Back_design = model.children[0].children.filter(
      (child) => child.name === "back"
    )[0];
    Cuff_style = model.children[0].children.filter(
      (child) => child.name === "Cuff"
    )[0];
    Pleats = model.children[0].children.filter(
      (child) => child.name === "Pleats"
    )[0];
    sleev = model.children[0].children.filter(
      (child) => child.name === "sleev"
    )[0];

    updateCollarStyle();
    updatePlacket();
    updateBackDesign();
    updateCuffStyle();
    updateCuff();
    updateSleev();
    updateButtonImage();

    updateMaterialFabric(oCurruentFabric ?? DEFAULT_FABRIC_FALLBACK);

    model.children.forEach((child) => {
      child.castShadow = true;
      child.receiveShadow = true;
    });
    Pleats.children[0].material.depthWrite = true;
    model.scale.set(0.21, 0.21, 0.21);
    scene.add(model);
  });
  if (document.body.classList.contains("line-loading-3d-preview")) {
    document.body.classList.remove("line-loading-3d-preview");
  }
}
const orbitControls = () => {
  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.enablePan = false;
  controls.minPolarAngle = Math.PI / 2;
  controls.maxPolarAngle = Math.PI / 2;
  controls.minZoom = 0.8;
  controls.maxZoom = 1.35;
  controls.enableZoom = false;
};

function loadLodingText() {
  loadingText = document.createElement("div");
  // loadingText.innerHTML = "Loading...";
  loadingText.classList.add("loader");
  container.appendChild(loadingText);
}

init();

const updateButtonImage = async () => {
  console.log("sButtons_texture", sButtons_texture);
  let buttonMaterial = Cuff_style.children[0].children[0].material;
  const textureLoader = new THREE.TextureLoader();
  const url = `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/Shirts/${sButtons_texture}.png`;

  textureLoader.load(url, function (texture) {
    // Dispose of the old texture to avoid memory leaks
    if (buttonMaterial.map) {
      buttonMaterial.map.dispose();
    }
    // Adjust texture settings
    texture.encoding = THREE.sRGBEncoding;
    texture.needsUpdate = true;

    buttonMaterial.map = texture;
    buttonMaterial.needsUpdate = true;
    buttonMaterial.metalness = 1;
    buttonMaterial.roughness = 1;
  });
};

const updateMaterialFabric = (fabric = DEFAULT_FABRIC_FALLBACK) => {
  console.log(fabric);
  oCurruentFabric = fabric;
  updateMaterialTextures(Pleats.children[0].material, fabric);
  updateContrastCollar();
  updateContrastCuffs();
  getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
  document.body.style.pointerEvents = "auto";
  // loadingText.remove();
};
function updateMaterialTextures(material, fabric) {
    const textureLoader = new THREE.TextureLoader();
    const loadTexture = (url, callback) => {
        textureLoader.load(url, (texture) => {
            texture.magFilter = THREE.NearestFilter;
            callback(texture);
            material.needsUpdate = true;
        });
    };

    if (fabric.repeatable_metalness_image_url) {
        loadTexture(fabric.repeatable_metalness_image_url, (texture) => {
            material.metalnessMap = texture;
        });
    }

    // Load and set roughness map
    if (fabric.repeatable_roughness_image_url) {
        loadTexture(fabric.repeatable_roughness_image_url, (texture) => {
            material.roughnessMap = texture;
        });
    }
    if (fabric.repeatable_displacement_image_url) {
        loadTexture(fabric.repeatable_displacement_image_url, (texture) => {
            material.displacement = texture;
        });
    }
    if (fabric.repeatable_normal_image_url) {
        loadTexture(fabric.repeatable_normal_image_url, (texture) => {
            material.normal = texture;
        });
    }

    // Load and set color map (diffuse map)
    const shirtColorUrl =
        fabric.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;
    if (shirtColorUrl) {
        loadTexture(shirtColorUrl, (texture) => {
            texture.encoding = THREE.sRGBEncoding;
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            const nTiling_percentages = 1;
            const tilingX =
                ((fabric.tiling_info && fabric.tiling_info.color_tiling_x) ||
                    1) * nTiling_percentages;
            const tilingY =
                ((fabric.tiling_info && fabric.tiling_info.color_tiling_y) ||
                    1) * nTiling_percentages;
            texture.repeat.set(tilingX, tilingY);
            material.map = texture;
        });
    }
    material.userData.colorInfo = fabric.color_info;

    // Update other material properties
    material.depthWrite = true;
    material.displacementScale = fabric.displacement_scale || 0;
    material.metalness = fabric.metalness || 0;
    material.specular_value = fabric.specular_value || 0;
    material.shininess = fabric.shininess;
    material.needsUpdate = true;
    setTimeout(() => {
        model.visible = true;
    }, 500);
}

function getColorIntensityCategory(color_r, color_g, color_b) {
  const toLinear = (c) =>
    c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
  // Normalize RGB values
  const rLinear = toLinear(color_r / 255);
  const gLinear = toLinear(color_g / 255);
  const bLinear = toLinear(color_b / 255);

  // Calculate luminance
  const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
  // console.log(color_r, color_g, color_b, "luminance", luminance);

  // Determine the intensity category
  let intensity = getIntensity(luminance);
  console.log(intensity, luminance);
  nCurruentIntensity = intensity;

  // Apply intensity to all lights
  // aLight.forEach((light) => {
  //     light.intensity = intensity;
  // });
}
function getIntensity(luminance) {
  switch (true) {
    case luminance < 0.001:
      return 20;
    case luminance < 0.005:
      return 13;
    case luminance < 0.01:
      return 11;
    case luminance < 0.05:
      return 9;
    case luminance < 0.1:
      return 5;
    case luminance < 0.25:
      return 4;
    case luminance < 0.3:
      return 2;
    case luminance < 0.4:
      return 2;
    case luminance < 0.5:
      return 1.5;
    case luminance < 0.6:
      return 1.5;
    case luminance < 0.7:
      return 1;
    case luminance < 0.8:
      return 0.8;
    case luminance < 0.9:
      return 0.5;
    default:
      return 0.1;
  }
}
const bindChangeEvent = (elementId, callback) => {
  // document.getElementById(elementId).onchange = callback;
};
const updateCollarStyle = () => {
  //console.log('collarStyleValue',Collar_style.children,  collarStyleValue)
  Collar_style.children.forEach((child) => {
    child.visible = false;
  });
  Collar_style.children.filter(
    (child) => child.name === collarStyleValue
  )[0].visible = true;
  updateHemShape();
};
const updateHemShape = () => {
  updatePlacket();
  updateBackDesign();
};

const updatePlacket = () => {
  Placket.children.forEach((child) => {
    child.visible = false;
  });

  if (collarStyleValue !== "Multicollar") {
    const collar_Style_Value = Placket.children.filter(
      (child) => child.name.substring(0, 4) === hemShapeValue.substring(0, 4)
    )[0];
    collar_Style_Value.visible = true;
    collar_Style_Value.children.forEach((child) => {
      child.visible = false;
    });
    collar_Style_Value.children.filter(
      (child) => child.name.substring(0, 4) === placketValue.substring(0, 4)
    )[0].visible = true;
    // document.getElementById("Placket").disabled = false;
    // document.getElementById("Back_design").disabled = false;
  } else {
    const sMultiCollar = Collar_style.children.filter(
      (child) => child.name === "Multicollar"
    )[0];
    sMultiCollar.children.forEach((child) => {
      child.visible = false;
    });
    console.log(sMultiCollar.children[hemShapeValue === "tail" ? 1 : 0]);
    sMultiCollar.children[hemShapeValue === "tail" ? 1 : 0].visible = true;
    // document.getElementById("Placket").disabled = true;
    // document.getElementById("Back_design").disabled = true;
  }
};

const updateBackDesign = () => {
  Back_design.children.forEach((child) => {
    child.visible = false;
  });
  const back_design_value = Back_design.children.filter(
    (child) => child.name.substring(0, 4) === hemShapeValue.substring(0, 4)
  )[0];

  back_design_value.visible = true;
  back_design_value.children.forEach((child) => {
    child.visible = false;
  });
  back_design_value.children.filter(
    (child) => child.name.substring(0, 4) === backDesignValue.substring(0, 4)
  )[0].visible = true;
  back_design_value.children.filter(
    (child) => child.name.substring(0, 4) === "Back_up".substring(0, 4)
  )[0].visible = true;
};

const updateCuffStyle = () => {
  console.log("Cuff_style", Cuff_style.children, cuffStyleValue);
  Cuff_style.children.forEach((child) => {
    child.visible = false;
  });
  Cuff_style.children.filter(
    (child) =>
      child.name ===
      (cuffStyleValue === "French_Double_Cuffs"
        ? "French_Single_Cuffs"
        : cuffStyleValue)
  )[0].visible = true;
};

const updateCuff = () => {
  console.log(Pleats.children);
  Pleats.children.forEach((child) => {
    child.visible = false;
  });
  Pleats.children.filter((child) => child.name === cuffValue)[0].visible = true;
};
const updateSleev = () => {
  // sleev.visible = !document.getElementById("sleev").checked
};
const updateContrastCuffs = () => {
  const textureLoader = new THREE.TextureLoader();
  console.log("contrastCuffs", contrastCuffs, Cuff_style);

  if (contrastCuffs && Cuff_style) {
    const loadTexture = (url, callback) => {
      textureLoader.load(url, (texture) => {
        callback(texture);
      });
    };
    loadTexture(
      `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/laper_Base_color.png`,
      (texture) => {
        Cuff_style.children[0].material.map = texture;
        Cuff_style.children[0].material.encoding = THREE.sRGBEncoding;
        Cuff_style.children[0].material.wrapS =
          Cuff_style.children[0].material.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(15, 15);
        console.log(Cuff_style.children[0].material);

        if (nCurruentIntensity <= 3) {
          Cuff_style.children[0].material.color.setRGB(255, 255, 200);
          Cuff_style.children[0].material.needsUpdate = true;
        }
      }
    );
  } else {
    console.log(oCurruentFabric);
    if (oCurruentFabric) {
      console.log(Cuff_style.children[0].material.type);
      updateMaterialTextures(Cuff_style.children[0].material, oCurruentFabric);
      Cuff_style.children[0].material.color.setRGB(1, 1, 1);
      Cuff_style.children[0].material.emissiveIntensity = 0;
      Cuff_style.children[0].material.needsUpdate = true;
    }
  }
};
const updateContrastCollar = () => {
  console.log("contrastCollar", contrastCollar);
  if (contrastCollar && Collar_style) {
    const textureLoader = new THREE.TextureLoader();
    const loadTexture = (url, callback) => {
      textureLoader.load(url, (texture) => {
        callback(texture);
      });
    };
    loadTexture(
      `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/laper_Base_color.png`,
      (texture) => {
        Collar_style.children[0].material.map = texture;
        Collar_style.children[0].material.encoding = THREE.sRGBEncoding;
        Collar_style.children[0].material.wrapS =
          Collar_style.children[0].material.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(20, 20);

        if (nCurruentIntensity <= 3) {
          Collar_style.children[0].material.emissive.setRGB(255, 255, 255);
          Collar_style.children[0].material.emissiveIntensity = 0.5;
          Collar_style.children[0].material.needsUpdate = true;
        }
      }
    );
  } else {
    if (oCurruentFabric) {
      updateMaterialTextures(
        Collar_style.children[0].material,
        oCurruentFabric
      );
      Collar_style.children[0].material.emissive.setRGB(0, 0, 0);
      Collar_style.children[0].material.emissiveIntensity = 0;
      Collar_style.children[0].material.needsUpdate = true;
    }
  }
};

// Usage
let previousSelectedDiv = null;
let price;
let fprice;
let metperperproduct;
let cmt;
let markupprice;
let finalprice;
metperperproduct = 2;
cmt = 1250;
markupprice = 2000;
// async function fetchFabrics() {
//     // const response = await axios.get('https://mtm.tg3ds.com/api/v1/fabrics/OZyYmEmZ?apikey=null&ticket=5Ce-ieTrXS3iRaLT5VyAbQyYUXL7dtvazqysiAKPNaq_q7nr-zQQT8q5sSNHPQfmBRM0Vjx5');
//     // ShowFabrics(response.data.data);
//     // console.log(response.data);
//     // model && updateMaterialFabric(response.data);
//     // oCurruentFabric = response.data

//     const responses = await axios.get('https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics');
//     // ShowFabrics(responses.data.data);
//     console.log(responses.data.data[149]);
//     model && updateMaterialFabric(responses.data.data[149]);
//     oCurruentFabric = responses.data.data[149];
//       allfabrics = response.data.data

// }
async function fetchFabrics() {
  const response = await axios.get(
    "https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics"
  );
  console.log(response.data.data[7]);
  // ShowFabrics(response.data.data);
  const fid = response.data.data?.filter((fabric) => fabric.id === defaultfabriccode);
  // oCurruentFabric = fid[0];
  oCurruentFabric = null;

  allfabrics = response.data.data;

  console.log(model);
  // updateMaterialFabric(response.data.data[7]);
}

function ShowFabrics(fabrics) {
  console.log(fabrics);
  const container = document.getElementById("fabric-container");
  let aFabricId = [
    "JjR9MPJ4",
    "5VWxz1DZ",
    "6ZY0OzJV",
    "JjR9M0w4",
    "r4G8vOEj",
    "GV5X38vj",
    "x4Jmv9gZ",
    "l4KWvP94",
    "LZ3LbJ74",
    "pZL6DPGj",
    "z4bmlXRZ",
    "9Z01xwP4",
  ];
  fabrics.forEach((fabric) => {
    if (fabric.repeatable_color_image_url) {
      const fabricDiv = document.createElement("div");
      fabricDiv.className = "fabric-div";

      // Create an image element
      const img = document.createElement("img");
      img.src = fabric.repeatable_color_image_url;
      img.alt = fabric.id;
      img.className = "fabric-image";

      const idDiv = document.createElement("div");
      idDiv.innerText = fabric.serial_number;
      idDiv.className = "fabric-serial_number";

      const priceDiv = document.createElement("div");
      priceDiv.innerText = fabric.price_per_yard;
      priceDiv.className = "fabric-price";

      fabricDiv.appendChild(img);
      fabricDiv.appendChild(idDiv);
      fabricDiv.appendChild(priceDiv);

      container.appendChild(fabricDiv);
      img.addEventListener("click", () => {
        updateMaterialFabric(oCurruentFabric ?? DEFAULT_FABRIC_FALLBACK);
        console.log(fabric);
        console.log(fabric);
        // sCurruntFabric = fabric;
        console.log(model);
        fprice = fabric.price_per_yard;
        finalprice = (fprice * metperperproduct + cmt + markupprice) * 1.25;
        console.log(fprice);
        price = document.getElementsByClassName("price")[0];
        console.log(price);
        price.innerHTML = finalprice + " Kr.";
      });
    }
  });
  if (document.body.classList.contains("line-loading")) {
    document.body.classList.remove("line-loading");
  }
}

//$(document).on("click", ".cm-modifier-drawer.isSelected .cm-drawer-container", function() {
$(document).on(
  "click",
  ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply, .cm-modifier-drawer .drawer2_apply, .cm-toggle-ele .cm-toggle-item",
  function (event) {

    // Added by softpulse
    if($(this).parents(".isSelected").find(".is-selected").hasClass("cm-drawer-other-option-btn")){
      $("body").removeClass("line-loading-3d-preview");
      this.classList.contains("inactive_button") ? this.classList.remove("inactive_button") : '';
      return;
    }

    if(event.isTrigger){
      setTimeout(() => {
        // Get all the parent divs with the class "cm-modifier-card-container"
        let parentDivs = document.querySelectorAll(".cm-modifier-card-container");
        let resultTitleText,
          resultTitleTextWithoutSpaces,
          childDiv,
          resultTitleDiv,filter_label,filter_label_value;;
  
        for (let i = 0; i < parentDivs.length; i++) {
          // Get the child div with the class "cm-modifier-card-wrapper"
          childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
          // Check if the child div exists
          if (childDiv) {
            //console.log('parentDivs', parentDivs[i].querySelector('.is-selected'));
            // Access data or perform actions on the child div
            console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper
            filter_label = childDiv.querySelector(".cm-modifier-col-title");
            // Find the children div with class "cm-modifier-result-title" within childDiv
            resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");
            //resultTitleDiv = parentDivs[i].querySelector('.is-selected .cm-drawer-title strong');
  
            //resultTitleDiv = event.isTrigger ? parentDivs[i].querySelector(".is-selected").querySelector('.cm-drawer-title strong') : childDiv.querySelector('.cm-modifier-result-title');
  
            if (resultTitleDiv) {
              resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
              filter_label_value = filter_label.textContent.trim();
              resultTitleTextWithoutSpaces = resultTitleText.replace(
                /[.\s:]+/g,
                "_"
              ); // Replace spaces and dots with underscores
              filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );
              console.log("Result Title:",i,filter_label_value, resultTitleTextWithoutSpaces); // Log the modified text content
            }
  
            if (filter_label_value == 'Collar_style') {
              if (resultTitleTextWithoutSpaces == "One_Piece_Multicollar") {
                resultTitleTextWithoutSpaces = "Multicollar";
              } else if (resultTitleTextWithoutSpaces == "Pin-Collar") {
                resultTitleTextWithoutSpaces = "Pin_collar";
              } else if (resultTitleTextWithoutSpaces == "Button_Down_(Hidden)") {
                resultTitleTextWithoutSpaces = "Button_Down_Hidden";
              } else if (resultTitleTextWithoutSpaces == "Button_Down") {
                resultTitleTextWithoutSpaces = "Button_Down";
              } else if (resultTitleTextWithoutSpaces == "Rounded_Widespread") {
                resultTitleTextWithoutSpaces = "Rounded_Widespread";
              } else if (resultTitleTextWithoutSpaces == "Cutaway") {
                resultTitleTextWithoutSpaces = "Cutaway";
              }
              collarStyleValue = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == 'Placket') {
              if (resultTitleTextWithoutSpaces == "Hidden_Buttons") {
                resultTitleTextWithoutSpaces = "Hidden_Placket";
              }
              placketValue = resultTitleTextWithoutSpaces;
              //console.log('placketValue', resultTitleTextWithoutSpaces)
            }
            if (filter_label_value == 'Back_design') {
              if (resultTitleTextWithoutSpaces == "Classic") {
                resultTitleTextWithoutSpaces = "plain";
              } else if (resultTitleTextWithoutSpaces == "Darts") {
                resultTitleTextWithoutSpaces = "darts";
              } else if (resultTitleTextWithoutSpaces == "Side_folds") {
                resultTitleTextWithoutSpaces = "side_fold";
              } else if (resultTitleTextWithoutSpaces == "Center_folds") {
                resultTitleTextWithoutSpaces = "centle_folf";
              }
              backDesignValue = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == 'Hem_shape') {
              if (resultTitleTextWithoutSpaces == "Tail") {
                hemShapeValue = "tail";
              } else {
                hemShapeValue = "straight";
              }
            }
            if (filter_label_value == 'Cuff_style') {
              if (resultTitleTextWithoutSpaces == "Single_Rounded") {
                resultTitleTextWithoutSpaces = "Single_Rounded_Cuffs";
              } else if (
                resultTitleTextWithoutSpaces == "Single_Rounded_(Adjustable)"
              ) {
                resultTitleTextWithoutSpaces = "Single_Rounded_Cuffs_Adjustable";
              } else if (
                resultTitleTextWithoutSpaces == "Milanese_cocktail_cuffs"
              ) {
                resultTitleTextWithoutSpaces = "Milanese_Cocktail_cuffs";
              }
              console.log(resultTitleTextWithoutSpaces);
  
              cuffStyleValue = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == 'Buttons') {
              sButtons_texture = resultTitleTextWithoutSpaces;
              updateButtonImage();
            } 
            if (filter_label_value == 'Contrast_collar') {
              if (resultTitleTextWithoutSpaces == "Yes_(Standard)") {
                contrastCollar = true;
              } else {
                contrastCollar = false;
              }
              console.log(contrastCollar);
            }        
            if (filter_label_value == 'Contrast_cuff') {
              if (resultTitleTextWithoutSpaces === "Yes_(Standard)") {
                contrastCuffs = true;
              } else {
                contrastCuffs = false;
              }
            }                     
            if (filter_label_value == 'Pleats') {
              cuffValue = resultTitleTextWithoutSpaces;                      
            }
            updateCollarStyle();
            updatePlacket();
            updateBackDesign();
            updateCuffStyle();
            updateCuff();
            updateSleev();
            updateContrastCollar();
            updateContrastCuffs();
          }
        }
        $("body").removeClass("line-loading-3d-preview");
        this.classList.contains("inactive_button") ? this.classList.remove("inactive_button") : '';
      }, 300);
    }
  }
);

const fabricLists = document.querySelectorAll(".cm-card-list fabric-list");

if (fabricLists.length > 0) {
  const firstFabricList = fabricLists[0];
  const contentWrapper = firstFabricList.querySelector(
    ".cm-card-content-wrapper"
  );

  if (contentWrapper) {
    const fabricId = contentWrapper.getAttribute("data-fabricid");
    defaultfabriccode = fabricId;
    console.log("First fabric ID:", fabricId);
  } else {
    console.log("No content wrapper found within the first fabric-list tag.");
  }
} else {
  console.log("No fabric-list tags found.");
}

fabricLists.forEach((fabricList) => {
  fabricList.addEventListener("click", function () {
    const contentWrapper = this.querySelector(".cm-card-content-wrapper");
    if (contentWrapper) {
      const fabricId = contentWrapper.getAttribute("data-fabricid");
      console.log("Clicked on fabric-list tag with data-fabricid:", fabricId);
      const fid = allfabrics?.filter((fabric) => fabric.id === fabricId);
      console.log("fid", fid, fabricId);
      updateMaterialFabric(fid[0] ?? DEFAULT_FABRIC_FALLBACK);
            oCurruentFabric = fid[0] ?? DEFAULT_FABRIC_FALLBACK;
    } else {
      console.log(
        "No content wrapper found within the clicked fabric-list tag."
      );
    }
  });
});
